import { render, staticRenderFns } from "./businessTableHisManage.vue?vue&type=template&id=c64faf90&scoped=true"
import script from "./businessTableHisManage.vue?vue&type=script&lang=js"
export * from "./businessTableHisManage.vue?vue&type=script&lang=js"
import style0 from "./businessTableHisManage.vue?vue&type=style&index=0&id=c64faf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64faf90",
  null
  
)

export default component.exports